module.exports = __webpack_public_path__ + "img/50.5198ddb3.jpg";